import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { ToastableItem } from '@radioking/shared/common-services';

import {
  PlanningCreateSlotFailure,
  PlanningCreateSlotSuccess,
  PlanningDeleteSlotFailure,
  PlanningDeleteSlotSuccess,
  PlanningEditSlotFailure,
  PlanningEditSlotSuccess,
  PlanningMoveSlotFailure,
  PlanningMoveSlotSuccess,
  SlotDropSameDayOnly,
  SlotOverrideExisting,
  TooltipMagicIcon,
  TooltipNoContent,
} from './states/planning.actions';

export const planningToasts: ToastableItem[] = [
  {
    action: PlanningCreateSlotSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.CREATE_SLOT_SUCCESS'),
  },
  {
    action: PlanningCreateSlotFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.CREATE_SLOT_ERROR'),
  },
  {
    action: PlanningEditSlotSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.EDIT_SLOT_SUCCESS'),
  },
  {
    action: PlanningEditSlotFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.EDIT_SLOT_ERROR'),
  },
  {
    action: PlanningMoveSlotSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.MOVE_SLOT_SUCCESS'),
  },
  {
    action: PlanningMoveSlotFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.MOVE_SLOT_ERROR'),
  },
  {
    action: PlanningDeleteSlotSuccess,
    level: 'success',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.DELETE_SLOT_SUCCESS'),
  },
  {
    action: PlanningDeleteSlotFailure,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.DELETE_SLOT_ERROR'),
  },
  {
    action: SlotOverrideExisting,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.SLOT_OVERRIDE'),
  },
  {
    action: SlotDropSameDayOnly,
    level: 'error',
    translationKey: marker('TOAST.SCHEDULE.PLANNING.SLOT_DROP_SAME_DAY'),
  },
  {
    action: TooltipMagicIcon,
    level: 'info',
    translationKey: marker('SCHEDULE.PLANNING.EDIT_MODAL_MAGIC_ICON'),
  },
  {
    action: TooltipNoContent,
    level: 'error',
    translationKey: marker('SCHEDULE.PLANNING.NO_PROGRAM_PLAYLIST'),
  },
];
